// @flow

import Resource from 'speed-js-core/src/api/Resource';

class WSOpenedResource extends Resource {
    opened() {
        return this.client._request(`${this._getBasePath()}opened/`, 'GET')
            .then((response) => response.data);
    }
}

export default WSOpenedResource;
